import React from "react";
import Checkout from "../components/Checkout";
import BreadcrumbTwo from "../components/BreadcrumbTwo";

const CheckoutPage = () => {
  return (
    <>
      <BreadcrumbTwo title={"Checkout"} />
      <Checkout />
    </>
  );
};

export default CheckoutPage;